import camelCase from 'lodash/camelCase';
import sum from 'lodash/sum';
import upperFirst from 'lodash/upperFirst';
import { bool, func } from 'prop-types';
import React, { Component } from 'react';
import { Col, FormGroup, Label, Row } from 'reactstrap';

import CurrencyFormat from '../../../generic/CurrencyFormat';
import CurrencyInput from '../../../generic/CurrencyInput';
import { getTooltipLabelWithText } from '../../../generic/Tooltip';
import { opportunityShape } from '../../../prop-types';
import { salesChannelsEnum } from '../../constants';
import HELP_TEXTS from '../../help-texts';
import { hasLowerCase } from '../../utils/utils';

const revenueTypes = [
  'Media Managed',
  'Media Self Service',
  'Creative',
  'CI',
  'Other',
];

const TooltipLabel = getTooltipLabelWithText(HELP_TEXTS);

export default class OpportunityBudget extends Component {
  handleRevenueChange = e => {
    const { onChange, opportunity } = this.props;
    onChange(e);

    onChange({
      target: {
        name: 'expectedRevenue',
        value: sum(
          revenueTypes.map(t => {
            const revenueField = hasLowerCase(t)
              ? `expectedRevenue${upperFirst(camelCase(t))}`
              : `expectedRevenue${t}`;
            return revenueField === e.target.name
              ? e.target.value
              : opportunity[revenueField];
          }),
        ),
      },
    });
  };

  render() {
    const { opportunity, readOnly, isSalesforceOpp } = this.props;
    const {
      campaignId,
      expectedRevenue,
      netClientBudget,
      salesChannel,
      selfServiceBudget,
      selfServiceSpentBudget,
      selfServiceNetClientBudget,
      selfServiceFreeMedia,
    } = opportunity;
    const isExpectedRevenueReadOnly =
      !!campaignId || readOnly || isSalesforceOpp;
    const isSalesChannelSelfService =
      salesChannel === salesChannelsEnum.SELF_SERVICE;

    return (
      <>
        {isSalesChannelSelfService && (
          <>
            <FormGroup row>
              <TooltipLabel
                helpKey="selfServiceBudget"
                text="Self-Service Budget"
                colWidth={4}
                section="info"
                resource="op"
                placement="right"
              />
              <Col sm={8}>
                <CurrencyFormat
                  id="op-selfServiceBudget"
                  className="form-control-plaintext"
                  name="selfServiceBudget"
                  value={selfServiceBudget || 0}
                  text
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <TooltipLabel
                helpKey="selfServiceSpentBudget"
                text="Self-Service Spent Budget"
                colWidth={4}
                section="info"
                resource="op"
                placement="right"
              />
              <Col sm={8}>
                <CurrencyFormat
                  id="op-selfServiceSpentBudget"
                  className="form-control-plaintext"
                  name="selfServiceSpentBudget"
                  value={selfServiceSpentBudget || 0}
                  text
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label sm={4} for="op-selfServiceNetClientBudget">
                Self-Service Net Client Budget
              </Label>
              <Col sm={8}>
                <CurrencyFormat
                  id="op-selfServiceNetClientBudget"
                  className="form-control-plaintext"
                  name="selfServiceNetClientBudget"
                  value={selfServiceNetClientBudget || 0}
                  text
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label sm={4} for="op-selfServiceFreeMedia">
                Self-Service Free Service
              </Label>
              <Col sm={8}>
                <CurrencyFormat
                  id="op-selfServiceFreeMedia"
                  className="form-control-plaintext"
                  name="selfServiceFreeMedia"
                  value={selfServiceFreeMedia || 0}
                  text
                />
              </Col>
            </FormGroup>
          </>
        )}
        <FormGroup row>
          <Label sm={4} for="op-netClientBudget">
            Net Client Budget
          </Label>
          <Col sm={8}>
            <CurrencyFormat
              id="op-netClientBudget"
              className="form-control-plaintext"
              name="netClientBudget"
              value={netClientBudget || 0}
              text
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <TooltipLabel
            helpKey="expectedRevenue"
            text="Expected Revenue"
            colWidth={4}
            section="info"
            resource="op"
            placement="right"
          />
          <Col sm={8}>
            <CurrencyFormat
              id="op-expectedRevenue"
              className="form-control-plaintext"
              name="expectedRevenue"
              value={expectedRevenue}
              text
            />
          </Col>
          <Col sm={12}>
            {revenueTypes.map(type => {
              const fieldName = hasLowerCase(type)
                ? `expectedRevenue${upperFirst(camelCase(type))}`
                : `expectedRevenue${type}`;
              return (
                <Row className="mb-3" key={fieldName}>
                  <Label
                    sm={4}
                    for={`op-${fieldName}`}
                    className="pl-5 required"
                  >
                    {type}
                  </Label>
                  <Col sm={8}>
                    <CurrencyInput
                      id={`op-${fieldName}`}
                      name={fieldName}
                      value={opportunity[fieldName]}
                      onChange={this.handleRevenueChange}
                      readOnly={isExpectedRevenueReadOnly}
                    />
                  </Col>
                </Row>
              );
            })}
          </Col>
        </FormGroup>
      </>
    );
  }
}

OpportunityBudget.propTypes = {
  opportunity: opportunityShape.isRequired,
  onChange: func,
  readOnly: bool,
  isSalesforceOpp: bool,
};

OpportunityBudget.defaultProps = {
  onChange: () => {},
  readOnly: undefined,
  isSalesforceOpp: false,
};
